<section class="content">
    <section class="employees-intro-section">
        <p class="typography-title-l">{{ 'my_profile.my_employees.title' | translate }}</p>
        <p class="typography-title-s description">{{ 'my_profile.my_employees.title_description' | translate }}</p>
    </section>

    <section class="employees-form">
        <section class="employees-form-intro">
            <p class="typography-title-m">{{ 'my_profile.my_employees.title_employees_data' | translate }}</p>
        </section>

        <section class="employees-form-content">
            <form class="company-atts-form">
                <section class="employees-table">
                    <app-table
                        [data]="employees"
                        [columns]="tableColumns"
                        [rowActions]="rowActions"
                        [showEmployeePhoneTooltip]="true"
                        (actionClicked)="onRowAction($event)"
                        [selectable]="false"
                        (toggleChanged)="onEmployeeToggle($event)">
                    </app-table>
                </section>
                <app-link class="typography-body-l add-btn" [size]="'large'" (onClick)="onAddEmployee()">{{'my_profile.my_employees.add_employee_button' | translate}}</app-link>
            </form>
        </section>
    </section>
    <section class="employees-form" *ngIf="userInfo.role == 'ADMIN' && userInfo.accountType == 'RETAIL'">
        <section class="employees-form-intro">
            <span class="typography-title-m">{{ 'my_profile.my_company.points_exchange_method_title' | translate }}</span>
        </section>

        <section class="flex flex-col" >
            <span>{{ 'my_profile.user_section.points_exchange_method_description' | translate }}</span>
            <div class="mb-2 flex flex-col gap-4 mt-4">
                <div class="flex gap-6">
                    <div class="flex gap-2 items-center cursor-pointer" (click)="onChangePointsExchangeMethod(true)">
                        <app-radio [checked]="pointsExchangeMethodByEmployee == true" />
                        <span class="typography-body-s-regular">{{'my_profile.user_section.points_exchange_method_by_employee' | translate}}</span>
                    </div>
                    <div class="flex gap-2 items-center cursor-pointer" (click)="onChangePointsExchangeMethod(false)">
                        <app-radio [checked]="pointsExchangeMethodByEmployee == false" />
                        <span class="typography-body-s-regular">{{'my_profile.user_section.points_exchange_method_by_account' | translate}}</span>
                    </div>
                </div>
                <alert *ngIf="pointsExchangeMethodByEmployee == false" type="warning" [icon]="true">
                    {{ 'my_profile.user_section.points_exchange_method_alert' | translate }}
                </alert> 
            </div>
        </section>
    </section>

    <section class="employees-save-button" *ngIf="userInfo?.role === 'ADMIN' && userInfo?.accountType !== 'ARCHITECT' && userInfo?.accountType !== 'DESIGNER'">
        <div class="buttonsSection primaryDefault">
            <app-button class="w-full md:w-auto" [skin]="'we'" [primary]="true" [size]="'medium'" [disabled]="!hasChanges" (onClick)="onSaveAll()" data-id="buttonId">
                <span>{{ 'my_profile.my_company.save_button' | translate }}</span>
            </app-button>
        </div>
    </section>
</section>

<app-confirm-modal
  [isOpen]="isConfirmModalVisible"
  [title]="'my_profile.delete_user' | translate"
  [message]="'my_profile.estas_seguro_de_que_qui' | translate"
  [confirmText]="'my_profile.confirmar' | translate"
  [cancelText]="'global.back' | translate"
  [buttonsInRow]="true"
  (onConfirm)="onConfirmDelete()"
  (onCancel)="isConfirmModalVisible = false"
  (onClose)="isConfirmModalVisible = false"
/>


<app-confirm-modal
  [isOpen]="isSuccessModalVisible"
  [title]="'my_profile.delete_user' | translate"
  [message]="'my_profile.el_contacto_ha' | translate"
  [confirmText]="'my_profile.continue_text' | translate"
  [hideFooter]="false"
  [cancelText]="''"
  [buttonsInRow]="true"
  (onConfirm)="closeSuccessModal()"
  (onClose)="closeSuccessModal()"
/>
